import { toast } from 'react-hot-toast'
import { copyTextToClipboard, tr } from 'mmfintech-commons'

import { Button } from 'mmfintech-portal-commons'
import { QRCodeSVG } from 'qrcode.react'

import PixLogo from '../../../assets/icons/pix-logo.svg?react'

import './previewPix.scss'

interface PreviewPixProps {
  value: string
  size?: number
}

export const PreviewPix = ({ value, size = 256 }: PreviewPixProps) => {
  return (
    <div className='preview-pix-wrapper'>
      <p className='text-center'>
        <PixLogo />
      </p>
      <p className='text-center'>
        {tr(
          'FRONTEND.DEPOSIT.RESULT.QR_CODE',
          'Open the app with your registered PIX key, choose Pay with Pix and scan the QR Code or copy and paste the code.'
        )}
      </p>
      <p className='text-center code'>
        <QRCodeSVG value={value} size={size} />
      </p>
      <p className='text-center'>
        <Button
          type='button'
          text={tr('FRONTEND.DEPOSIT.RESULT.COPY_CODE', 'Copy code')}
          onClick={() => {
            copyTextToClipboard(value)
            toast.remove()
            toast.success(tr('FRONTEND.DEPOSIT.RESULT.QR_CODE_COPIED', 'Code is copied to clipboard').toString())
          }}
        />
      </p>
    </div>
  )
}
